class Geopopup {
  constructor(node) {
    this.storageKey = 'pattanl_geo_popup_shown'

    this.node = node
    this.modal = node.querySelector('[data-modal]')
    this.toggles = [...node.querySelectorAll('[data-modal-toggle]')]

    this.id = this.modal.dataset.popupId
    this.delay = parseInt(this.modal.dataset.popupDelay, 10)
    this.showPopup = this.checkIfNeedsToShow()

    console.log(this.delay)
    // this.stateManager = stateManager

    // this.stateManager.on('modal:close', this.onClose.bind(this))
    if (this.showPopup) {
      this.init()
    }
  }

  checkIfNeedsToShow() {
    if (window.location.hash === '#from-other-store') {
      localStorage.setItem(this.storageKey, true);
      window.location.hash = '';
    }
  
    return localStorage.getItem(this.storageKey) !== 'true'
  }

  init() {
    setTimeout(() => {
      this.open()
    }, this.delay * 1000)


    this.toggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        this.close()
      })
    })
  }

  open() {
    this.node.hidden = false
    this.modal.hidden = false

    // Repaint
    this.node.offsetHeight;

    this.node.classList.add('open')
    this.modal.classList.add('open')
  }

  close() {
    this.node.classList.remove('open')
    this.modal.classList.remove('open')

    localStorage.setItem(this.storageKey, true)
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const modalsComponent = document.querySelector('[data-component="modals"]')

  new Geopopup(modalsComponent)
  // const geopopupComponent = document.querySelector('[data-component="geopopup"]')


})